import React from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';
import AdvertModal from "components/AdvertModal/AdvertModal";
import IconSvg from 'components/IconSvg';
import {FormattedMessage} from "react-intl";

class AdvertNew extends React.Component {
    static propTypes = {
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        serviceTypeValues: PropTypes.array.isRequired,
        onAdvertCreate: PropTypes.func.isRequired,
        canCreateAdvert: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
    }

    componentWillMount() {
        this.setState({
            open: false
        });
    }

    toggle() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        const {priceValuesVoice, priceValuesSms, serviceTypeValues, onAdvertCreate, canCreateAdvert} = this.props;

        return (
            <div>
                <a className="clickable" onClick={this.toggle}>
                    <IconSvg id="add"/>
                </a>

                {canCreateAdvert &&
                <AdvertModal serviceTypeValues={serviceTypeValues} priceValuesVoice={priceValuesVoice} priceValuesSms={priceValuesSms}
                             onAdvertFormSubmit={onAdvertCreate} isOpen={this.state.open}
                             onToggle={this.toggle}/>
                }

                {!canCreateAdvert &&
                <Modal keyboard autoFocus isOpen={this.state.open} toggle={::this.toggle} modalClassName="modal-small">
                    <ModalHeader toggle={::this.toggle}>
                        <FormattedMessage id="advert_modal.phone_number_limit.title"
                                          defaultMessage="Phone number limit reached"/>
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage id="advert_modal.phone_number_limit.text"
                                          defaultMessage="Your phone number limit was reached. Feel free to contact us if you need to use more public numbers."/>
                    </ModalBody>
                </Modal>
                }
            </div>
        )
    }
}

export default AdvertNew;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Controls/AdvertNew.jsx